// @flow

export const getWeekDay = (dueDate: string, weekDaysTemplate: ImmutableArray<string>) => {
  const newDate = hydrateDate(dueDate);
  return weekDaysTemplate[newDate.getDay()];
};

export const hydrateDate = (stringDate: string) => {
  const dateArr = stringDate.split('-').map(Number);
  return new Date(
    dateArr[0],
    dateArr[1] - 1,
    dateArr[2]
  );
};
